import React, { useState, useEffect } from "react";
import SummaryNative from "./summary.native";
import IndexedDBService from "../../services/indexedDB/IndexedDB.service";
import appletSubgroupService from "../Inspection/services/applet-subgroup.service";
import AppletSubgroups from "../../models/applet/applet-subgroup.entity";
import InspectionStepLocalDB from "../../models/indexedDB/inspection-step-local-db.entity";
import { useSelector } from "react-redux";
import { ProtectedRoute } from "../Auth/ProtectedRoute/ProtectedRoute ";
import { useHistory } from "react-router-dom";

const SummaryContainer = () => {
  const state: any = useSelector(state => state);
  const history = useHistory();

  const { atualUniqueID, atualPlate, atualAppletProfileId } = state;
  const [inspectionSteps, setInspectionSteps] = useState([]);
  const [appletSubgroups, setAppletSubgroups] = useState<AppletSubgroups[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const getInspectionInfo = () => {
    setLoading(true);
    IndexedDBService.getByProperty('unique_identifier', atualUniqueID)
      .then((result: any) => {
        setInspectionSteps(result.map((item: any) => new InspectionStepLocalDB(item)));
      })
      .catch((err: any) => {
        throw new Error(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const getApplets = () => {
    const steps = appletSubgroupService.getAppleSubgroupList(atualAppletProfileId);
    const atualProfile = steps.profiles
      .find((profile) => profile.id === atualAppletProfileId);
    setAppletSubgroups(atualProfile!.appletSubgroups);
  }

  const getAppletName = (appletId: string) => {
    const applet = appletSubgroups.find((item: AppletSubgroups) => item.id === appletId);
    return applet!.title;
  }

  const editAppletPhoto = (applet: InspectionStepLocalDB) => {
    const { uniqueIdentifier, appletSubgroupId, id } = applet;
    history.push(`/inspection?unique=${uniqueIdentifier}&appletId=${appletSubgroupId}&id=${id}`);
  }

  const goToSuccess = () => {
    history.push('summary/success');
  }

  useEffect(() => {
    getApplets();
    IndexedDBService.createdDB();
    setTimeout(() => {
      getInspectionInfo();
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ProtectedRoute>
      <SummaryNative
        inspectionSteps={inspectionSteps}
        getAppletName={getAppletName}
        atualPlate={atualPlate}
        loading={loading}
        editAppletPhoto={editAppletPhoto}
        goToSuccess={goToSuccess}
      />
    </ProtectedRoute>
  )
}

export default SummaryContainer;